export const clientErrorReportLimits = {
  message: 2000,
  stack: 12000,
  componentStack: 12000,
  url: 2000,
  userAgent: 1000,
};

export function sanitizeClientErrorUrl(value: string) {
  try {
    const url = new URL(value);
    if (url.protocol !== "https:" && url.protocol !== "http:") {
      return "";
    }
    return `${url.origin}${url.pathname}`;
  } catch {
    return "";
  }
}
